export default "__VITE_ASSET__a3f286a3__"